import { Box, Stack, Typography, useMediaQuery } from "@mui/material";
import React from "react";
import { ReportForm } from "./ReportForm";
import { ReportDisclaimer } from "./ReportDisclaimer";
import { tablet } from "utils";
import { Card } from "components/Card";

export const ReportFormContainer = ({ mobile, submit, isLoading }) => {
  const matchesTablet = useMediaQuery(tablet);

  return mobile ? (
    <Stack spacing={4} pt="5rem">
      <ReportForm
        submit={submit}
        isLoading={isLoading}
        title={
          <div>
            <Typography
              variant="h1"
              fontSize={matchesTablet ? "24px" : "36px"}
              color="primary"
              textAlign="center"
              px="0.5rem"
            >
              Pasitikrinkite savo verslo finansinę sveikatą!
            </Typography>
            <Typography variant="h2" fontSize={matchesTablet ? "20px" : "28px"} color="textBlack" textAlign="center">
              Suveskite norimos patikrinti įmonės kodą
            </Typography>
          </div>
        }
      />
      <ReportDisclaimer />
    </Stack>
  ) : (
    <Stack
      pt="5rem"
      alignItems="center"
      justifyContent="space-around"
      sx={{
        background: "linear-gradient(to bottom, #ffffff 50%, #fdf6ee 50%)",
        height: "100%",
        padding: { xs: "1rem", md: "0" },
      }}
    >
      <Box width="80%">
        <Card>
          <ReportForm
            submit={submit}
            isLoading={isLoading}
            title={
              <div>
                <Typography variant="h1" color="primary" textAlign="center">
                  Suveskite norimos patikrinti
                </Typography>
                <Typography variant="h1" color="textBlack" textAlign="center">
                  įmonės kodą
                </Typography>
              </div>
            }
          />
        </Card>
      </Box>

      <ReportDisclaimer />
    </Stack>
  );
};
